import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';



const ScreenshotsCarousel = ({ caseStudy }) => {
  const items = Array.isArray(caseStudy?.screenshots)
    ? caseStudy.screenshots
    : caseStudy?.screenshots ? [caseStudy.screenshots] : [];

  if (!items.length) return null;

  return (
    <Swiper
      modules={[Navigation, Pagination, A11y]}
      slidesPerView={1}
      spaceBetween={16}
      loop={items.length > 1}
    >
      {items.map((file, idx) => (
        <SwiperSlide key={file || idx}>
          <img
            src={`https://api.rashtechinfo.com/uploads/${file}`}
            alt={`Project screenshot ${idx + 1}`}
            loading="lazy"
            style={{ width: '100%', height: "100%", display: 'block', borderRadius: "20px" }}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ScreenshotsCarousel;